import React from "react";

/**
 * Seo — gestion native des balises <head> (compatible React 19, sans react-helmet-async).
 * Idempotent : met à jour ou crée chaque balise, remplace les JSON-LD gérés.
 */
const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (content == null || content === "") return;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const applySeo = ({ title, description, keywords, canonical, ogImage, noindex = false, jsonLd = [] }) => {
  if (title) document.title = title;
  upsertMeta("name", "description", description);
  upsertMeta("name", "keywords", keywords);
  upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
  upsertMeta("property", "og:title", title);
  upsertMeta("property", "og:description", description);
  upsertMeta("property", "og:url", canonical);
  upsertMeta("property", "og:type", "website");
  upsertMeta("property", "og:locale", "fr_FR");
  upsertMeta("property", "og:image", ogImage);

  let link = document.head.querySelector('link[rel="canonical"]');
  if (canonical) {
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
  } else if (link) {
    link.remove();
  }

  document.head.querySelectorAll("script[data-seo-jsonld]").forEach((s) => s.remove());
  jsonLd.forEach((obj) => {
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.setAttribute("data-seo-jsonld", "1");
    s.textContent = JSON.stringify(obj);
    document.head.appendChild(s);
  });
};

export const Seo = (props) => {
  React.useEffect(() => {
    applySeo(props);
  });
  return null;
};

export default Seo;
